module.exports = __webpack_public_path__ + "static/media/gk-pommes-solo.b5b40c99.png";